import moment from 'moment'

export const formatDate = date => {
  return moment(date).format('DD/MM/YYYY')
}

export default function cutString(string, size) {
  if (string.length <= size) {
    return string;
  }

  const cuttedString = string.substring(0, size);
  const spaceIndex = string.lastIndexOf(" ");

  if (spaceIndex <= 0) {
    return cuttedString + '...';
  }

  return cuttedString.substring(0, spaceIndex);

}

export const emailValido = (email) => {
  const regex = /\S+@\S+\.\S+/;
  return regex.test(email);
}

export const validateNumber = (value, size) => {
  if (!value) return "Campo obrigatório";
  if (value.replace(/\D/g,'').length !== size) return "Formato inválido";
  return undefined;
}

export const validateCPF = (value) => {
  if (!value) return "Campo obrigatório";
  if (!isValidCpf(value)) return "CPF inválido";
  return undefined;
}

function isValidCpf(cpf) {
  // Remove caracteres não numéricos
  cpf = cpf.replace(/[^\d]+/g, '');

  if (cpf.length !== 11) return false;

  // Rejeita CPFs com todos os dígitos iguais (ex: 111.111.111-11)
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  // Validação do primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(9))) return false;

  // Validação do segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(10))) return false;

  return true;
}